var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    y: 0.702,
    fill: "#99A2AD",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M28.791 13.648c.97.25 1.732.975 1.99 1.896.469 1.67.469 5.158.469 5.158s0 3.487-.469 5.158c-.261.924-1.024 1.65-1.99 1.895-1.754.447-8.791.447-8.791.447s-7.033 0-8.791-.447c-.97-.249-1.732-.975-1.99-1.895-.469-1.67-.469-5.158-.469-5.158s0-3.488.469-5.158c.261-.924 1.024-1.65 1.99-1.896 1.758-.446 8.791-.446 8.791-.446s7.037 0 8.791.446m-5.194 7.054-5.845 3.214v-6.43z",
    clipRule: "evenodd"
  })));
};
export default SvgYoutube;